import React from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { StyledSection, StyledContentBlock, MainTitle } from './styled';
import Earn from './Earn';
import Verse from './Verse';
import Play from './Play';
import Learn from './Learn';

const SpendRewards = () => {
  return (
    <>
      <StyledSection>
        <StyledContentBlock>
          <MainTitle>
            <FormattedMessage id="home.spendrewards.title" />
          </MainTitle>
        </StyledContentBlock>
      </StyledSection>
      <Earn />
      <Verse />
      <Play />
      <Learn />
    </>
  );
};

export const query = graphql`
  fragment SpendRewards on Json {
    spendrewards {
      title
    }
  }
`;

export default SpendRewards;
